module.exports = __webpack_public_path__ + "r-v3/img/device-volume_on.6487e2b7.svg";